import { Box, Button, Typography } from '@mui/material';
import { ParameterSetTable } from './ParameterSetTable'

const ParameterSets = () => {

    const CreateParameterSetButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"edit-parameter-set"}
        >
            CREATE PARAMETER SET
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Parameter Sets</Typography>
                </Box>
                <Box>
                    <CreateParameterSetButton />
                </Box>
            </Box>
            <ParameterSetTable />
        </div>
    )
}

export default ParameterSets;